import Checkbox from './Checkbox';

export default Checkbox;


//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_rc-checkbox@2.1.1@rc-checkbox/es/index.js
// module id = 215
// module chunks = 0